import { useEffect, useState } from "react";
import { getFutureGames } from "../services/api";
import GameCard from "../components/GameCard";
import Loading from "../components/Loading";

export default function JogosDaRodada() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchGames() {
      const data = await getFutureGames();
      setGames(data);
      setLoading(false);
    }
    fetchGames();
  }, []);

  if (loading) return <Loading />;

  return (
    <div className="page">
      <h1>Jogos da Rodada</h1>
      {games.map((game, i) => (
        <GameCard key={i} game={game} />
      ))}
    </div>
  );
}
